import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'
import Swiper from 'swiper/bundle'

const gallery = document.querySelector('.cc-gallery')
const thumbs = document.querySelector('.cc-gallery-thumbnails')

if (gallery) {
  Fancybox.bind('.cc-gallery a', {
    groupAll: true,
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },
    Thumbs: {
      type: 'classic',
    },
  })

  if (thumbs) {
    const thumbnails = new Swiper('.cc-gallery-thumbnails__slider', {
      slidesPerView: 3,
      spaceBetween: 15,
      breakpoints: {
        992: {
          spaceBetween: 20,
        },
      },
    })

    new Swiper('.cc-gallery-slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      thumbs: {
        swiper: thumbnails,
      },
      navigation: {
        nextEl: '.cc-gallery-thumbnails__nav--next',
        prevEl: '.cc-gallery-thumbnails__nav--prev',
      },
    })
  }
}

const form = document.querySelector('form.variations_form')
if (form) {
  let data = form.getAttribute('data-product_variations')
  data = JSON.parse(data)

  document.querySelectorAll('.variations select').forEach(function (select) {
    if ('pa_duree' !== select.getAttribute('id')) {
      select.querySelectorAll('option').forEach(function (option) {
        if (!option.value) {
          return
        }

        let pricing = ''
        data.forEach(function (row) {
          if (row.attributes[select.name] == option.value) {
            pricing = row.price_html
          }
        })

        const radio = document.createElement('input')
        radio.type = 'radio'
        radio.name = select.name
        radio.value = option.value
        radio.checked = option.selected
        const label = document.createElement('label')
        const textWrap = document.createElement('span')
        const text = document.createTextNode(option.text)
        textWrap.appendChild(text)
        textWrap.classList.add('cc-swatch__title')
        label.appendChild(radio)
        label.appendChild(textWrap)
        const span = document.createElement('span')
        span.classList.add('cc-swatch__price')
        span.innerHTML = pricing
        label.appendChild(span)
        const div = document.createElement('div')
        div.classList.add('cc-swatch')
        div.appendChild(label)
        select.closest('div').appendChild(div)

        radio.addEventListener('click', function () {
          select.value = radio.value
          $(select).trigger('change')
        })
      })

      select.style.display = 'none'
    }
  })
}

const tabLinks = document.querySelectorAll('.wc-tabs a')
if (tabLinks) {
  ;[...tabLinks].map((link) => {
    link.addEventListener('click', () => {
      const list = link.parentNode
      list.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    })
  })
}

// when variation really change
$('form.variations_form').on('show_variation', function (event, variation) {
  $('p.price').html(variation.price_html)
  //console.log('Prix (HTML) :', variation.price_html)
  //console.log('Prix brut :', variation.display_price)
})

